/**
 * @generated SignedSource<<a219f750f431314737143dbd3d76a9ed>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type AgentBadge_agent$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventCanceled_event$fragmentType: FragmentType;
export type JobEventCanceled_event$data = {|
  +actor: {|
    +node: ?{|
      +name?: string,
      +organization?: ?{|
        +slug: string,
      |},
      +uuid?: string,
      +$fragmentSpreads: AgentBadge_agent$fragmentType,
    |},
  |},
  +exitStatus?: any,
  +timestamp: any,
  +$fragmentType: JobEventCanceled_event$fragmentType,
|};
export type JobEventCanceled_event$key = {
  +$data?: JobEventCanceled_event$data,
  +$fragmentSpreads: JobEventCanceled_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventCanceled_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "exitStatus",
          "storageKey": null
        }
      ],
      "type": "JobEventCanceled",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobEventActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "organization",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Agent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node/*: any*/).hash = "131569304bc324c673cbc9c4e365aef7";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventCanceled_event$fragmentType,
  JobEventCanceled_event$data,
>*/);
